import { motion } from "framer-motion";
import { Siren } from "lucide-react";
import { waLink } from "../config";

export const FloatingWhatsApp = () => (
  <motion.a
    href={waLink("*LAPORAN DARURAT 24 JAM*\n\nPak Kades, saya butuh bantuan segera.\n\nKejadian: ")}
    target="_blank"
    rel="noopener noreferrer"
    data-testid="floating-whatsapp-emergency-button"
    initial={{ opacity: 0, scale: 0.6, y: 20 }}
    animate={{ opacity: 1, scale: 1, y: 0 }}
    transition={{ delay: 1.6, duration: 0.6, ease: [0.16, 1, 0.3, 1] }}
    whileHover={{ scale: 1.05 }}
    whileTap={{ scale: 0.96 }}
    className="fixed bottom-5 right-5 sm:bottom-7 sm:right-7 z-50 inline-flex items-center gap-2.5 rounded-full bg-[#25D366] text-white pl-4 pr-5 py-3.5 font-semibold text-sm shadow-[0_16px_40px_rgba(37,211,102,0.4)] animate-pulse-ring"
  >
    <Siren size={19} />
    <span className="hidden sm:inline">Lapor Pak Kades</span>
    <span className="hidden md:inline text-white/80 font-normal text-xs">(Darurat 24 Jam)</span>
    <span className="sm:hidden">Darurat</span>
  </motion.a>
);
